import { render } from "./HeaderWrapper.vue?vue&type=template&id=26e5ceba&ts=true"
import script from "./HeaderWrapper.vue?vue&type=script&lang=ts"
export * from "./HeaderWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "/home/circleci/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__